import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "animate-pulse inline-block w-full bg-gray-300 h-full rounded-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.name ? _ctx.name : _ctx.defaultValue), 1))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, "   "))
}